import type { DefaultResponseBody, ListResponseBody, Video } from "@gerama/types";
import type { ApiClient } from "../client";

export function createCoreVideosApi(client: ApiClient) {
  return {
    list: (
      params: {
        page?: number;
        limit?: number;
        categoryId?: number;
        artistId?: number;
        songId?: number;
        search?: string;
        sort?: "newest" | "popular" | "likes" | "trending";
      } = {},
      signal?: AbortSignal,
    ) =>
      client
        .request<ListResponseBody<Video>>("/videos", { query: { ...params }, signal })
        .then((res) => res.data ?? { list: [], count: 0 }),

    /** Suggested videos for a detail page — same artist, then category, then newest; never empty while anything else is published. */
    related: (id: number | string, signal?: AbortSignal) =>
      client
        .request<ListResponseBody<Video>>(`/videos/${id}/related`, { query: { limit: 12 }, signal })
        .then((res) => res.data?.list ?? []),

    detail: (id: number | string, signal?: AbortSignal) =>
      client
        .request<DefaultResponseBody<Video>>(`/videos/${id}`, { signal })
        .then((res) => res.data as Video),

    /** Signed-in only: a single-file URL capped to the plan's download quality. */
    download: (id: number | string) =>
      client
        .request<DefaultResponseBody<{ url: string; maxKbps?: number }>>(`/videos/${id}/download`)
        .then((res) => res.data),

    /** Video counterpart of `songs.streamUrl` — see its doc comment. */
    streamUrl: (id: number | string) => `${client.baseUrl}/videos/${id}/stream`,
  };
}
